import React from 'react';
import { Paper,Divider, Button } from '@material-ui/core';
import { FilterComponent } from '../../../shared_elements';
import Skeleton from '@material-ui/lab/Skeleton';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ownerGraphFilterOps } from '../'
import { jetStreamInstance } from '../../Leases';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
Highcharts.setOptions({
    lang: {
      numericSymbols: ["k", "M", "B", "T"],
      thousandsSep: ","
    }
  });
const CashflowOwnerGraph = ({cashflowOwnerGraphData, skeletonLoader, filter, getResponseBack, callExternalFunction, moveFn}) => {
    let filterOptions = Object.assign({}, ownerGraphFilterOps);
    const options = {
        chart: {
            zoomType: 'xy',
            panning: true,
            panKey: 'shift',
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b><br/>',
            valuePrefix: 'US$',
        },
        noData: {
            style: {
                fontWeight: 'bold',
                fontSize: '15px'
            }
        },
        title: {
            text: `Based on ${jetStreamInstance?'Owner/SPV':'Owner'}`,
            align: 'left',
            style: {
                fontFamily: 'Conv_IBMPlexSans-Regular',
                fontSize:'16px'
            }
        },
        subtitle: {
            text: `${cashflowOwnerGraphData.title ? cashflowOwnerGraphData.title : ''}`,
            align: 'left'
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Amount(US$)'
            }
        },
        xAxis: {
            categories: cashflowOwnerGraphData && cashflowOwnerGraphData.cashflow_categories && cashflowOwnerGraphData.cashflow_categories.x_axis && cashflowOwnerGraphData.cashflow_categories.x_axis.categories
        },
        legend: {
            enabled: true
        },
        plotOptions:{
            series:{
                cursor: 'pointer',
                events: {
                    click: function (event) {
                        callExternalFunction(event.point.series.name, event.point.category, 'basedOnOwner');
                    }
                }
            }
        },
        series: cashflowOwnerGraphData && cashflowOwnerGraphData.reserve_cashflow,
        credits: false,
        exporting: {
            buttons: {
                contextButton: {
                  menuItems: ['downloadPNG', 'downloadPDF'],
                }
            },
            filename: 'Cashflow-Based on Owner Chart',
         }
    }

    return (
        skeletonLoader ? <Skeleton variant="rect" height={440} width='100%' /> : 
        <Paper style={{minHeight:'460px', position:'relative'}}>
            <div style={{padding:'0 5px'}}>
                <FilterComponent 
                    filter={filter}
                    filterMenu={filterOptions}
                    getResponseBack={(applyFilter) => getResponseBack(applyFilter)}
                />
            </div>
            <Divider />
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
            <div style={{textAlign:'center', position:'absolute', bottom:'10px', width:'100%'}}>
                <ul className="list-inline">
                    <li className="list-inline-item">
                        <Button disabled={cashflowOwnerGraphData && cashflowOwnerGraphData.pagination && cashflowOwnerGraphData.pagination.page == 1 ? true : false} onClick={(e) => moveFn('prev')} style={{cursor:'pointer'}}>Prev</Button>
                    </li>
                    <li className="list-inline-item">
                        <Button disabled={parseInt(cashflowOwnerGraphData && cashflowOwnerGraphData.pagination && cashflowOwnerGraphData.pagination.page)*parseInt(cashflowOwnerGraphData && cashflowOwnerGraphData.pagination && cashflowOwnerGraphData.pagination.per_page) < parseInt(cashflowOwnerGraphData && cashflowOwnerGraphData.pagination && cashflowOwnerGraphData.pagination.total) ? false:true} onClick={(e) => moveFn('next')} style={{cursor:'pointer'}}>Next</Button>
                    </li>
                </ul>
            </div>
        </Paper>
    )
}
export default CashflowOwnerGraph
